/**
 * .tuMetrics {"tu1": 0.95, "tu2": 0.97, "tu3": 1, "notes": "unknown → string for store catch blocks", "tuVersion": "2.5"}
 * .help "Turns a catch (unknown) into a user-facing message without `any`."
 */
export function errorMessage(error: unknown): string {
  if (error instanceof Error) return error.message;
  return String(error);
}
